module.exports = __webpack_public_path__ + "static/media/016yhkgl.a4b17f76.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/016yhkgl.jpg
// module id = 635
// module chunks = 0 1